import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=bca32f1a&scoped=true&"
import script from "./Cookies.vue?vue&type=script&lang=js&"
export * from "./Cookies.vue?vue&type=script&lang=js&"
import style0 from "./Cookies.vue?vue&type=style&index=0&id=bca32f1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca32f1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bca32f1a')) {
      api.createRecord('bca32f1a', component.options)
    } else {
      api.reload('bca32f1a', component.options)
    }
    module.hot.accept("./Cookies.vue?vue&type=template&id=bca32f1a&scoped=true&", function () {
      api.rerender('bca32f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/Cookies.vue"
export default component.exports